export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5564.d3547a61.jpg";